module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-search-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "subHeader",
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('div', [_vm._v("Select one of your pre-saved meals from the list")])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isLoading) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.savingText'))
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading) ? _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.meals), function(meal, index) {
    return _c('mu-list-item', {
      key: meal.meal_id,
      attrs: {
        "disableRipple": ""
      },
      on: {
        "click": _vm.loadFoods
      }
    }, [_vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(meal.meal_name))]), 0, meal.meal_id), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      on: {
        "click": function($event) {
          return _vm.loadMeal(meal)
        }
      },
      slot: "describe"
    }, [_vm._v("\n          Contains " + _vm._s(meal.count) + " foods\n        ")]), _vm._v(" "), _c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "icon": "more_vert",
        "scroller": _vm.scroller
      },
      slot: "right"
    }, [_c('mu-menu-item', {
      attrs: {
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteMeal(meal.meal_id)
        }
      }
    })], 1)], 1)
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97ae0646","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/MyMeals/MyMeals.vue
// module id = 3265
// module chunks = 1